import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

interface TooltipLabelProps {
  email?: string;
  name?: string;
}

const TooltipLabel = ({ email, name }: TooltipLabelProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const color = theme.palette.neutral['00'];
  return (
    <Container>
      <Typography variant={TypographyVariant.bodyMd2} color={color}>
        {t('leftNavigation.manageAccount', { defaultValue: 'Manage account' })}
      </Typography>
      <Typography variant={TypographyVariant.bodyMd1} color={color}>
        {name}
      </Typography>
      <Typography variant={TypographyVariant.bodyMd1} color={color}>
        {email}
      </Typography>
    </Container>
  );
};

export default TooltipLabel;

const Container = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
`;
